import { http_client } from "@/plugins/http_client";

const obtenerDelegado = async () =>
    await http_client("api/v1/usuario-delegado", {}, "get");

const listarEmpleadosEstablecimiento = async (params = {}) =>
    await http_client("api/v1/usuario-delegado/empleados", params, "get");

const asignarDelegado = async (idUsuarioDelegado) =>
    await http_client("api/v1/usuario-delegado", { id_usuario_delegado: idUsuarioDelegado }, "put");

export default {
    obtenerDelegado,
    listarEmpleadosEstablecimiento,
    asignarDelegado,
};
